<ng-container
  *ngIf="resource"
>
  <div class=op-tab-content--header>
    <span class="op-tab-content--header-icon spot-icon spot-icon_nextcloud-circle op-files-tab--icon op-files-tab--icon_nextcloud"></span>
    <span class="op-tab-content--header-text" [textContent]="storage.name"></span>
    <a
      class="op-tab-content--header-action spot-link"
      aria-label="{{text.openStorage()}}"
      [title]="text.openStorage()"
      [href]="storageFilesLocation"
      target="_blank"
    >
      <span class="spot-icon spot-icon_external-link"></span>
    </a>
  </div>

  <op-storage-information
    *ngFor="let infoBox of storageInformation | async"
    class="op-files-tab--storage-info-box"
    data-qa-selector="op-files-tab--storage-information"
    [content]="infoBox"
  ></op-storage-information>

  <ul
    class="spot-list spot-list_compact op-file-list"
    data-qa-selector="file-list"
  >
    <li
      *ngFor="let fileLink of fileLinks$ | async; let i = index;"
      class="spot-list--item op-file-list--item"
      data-qa-selector="file-list--item"
      op-file-link-list-item
      [fileLink]="fileLink"
      [disabled]="disabled"
      [allowEditing]="allowEditing$ | async"
      (removeFileLink)="removeFileLink(fileLink)"
    ></li>
  </ul>

  <p
    *ngIf="(showLinkFilesAction | async) && (allowEditing$ | async)"
    class="spot-body-small op-file-list--actions"
  >
    <button
      *ngIf="storageFileLinkingEnabled"
      type="button"
      class="spot-link op-file-list--action-button"
      data-qa-selector="op-file-list--link-existing-file-button"
      (click)="openLinkFilesDialog()"
    >
      <span class="spot-icon spot-icon_add-link"></span>
      <span [textContent]="text.actions.linkExisting"></span>
    </button>
    <button
      *ngIf="storageFileUploadEnabled"
      type="button"
      class="spot-link op-file-list--action-button"
      data-qa-selector="op-file-list--upload-file-button"
      (click)="openSelectLocationDialog()"
    >
      <span class="spot-icon spot-icon_upload-arrow"></span>
      <span [textContent]="text.actions.uploadFile"></span>
    </button>
  </p>
</ng-container>
